<h2 [ngClass]="{ 'required': required }" [attr.title]="required ? ' * Required' : null">Conditions<button class="icon--add btn--default" type="button" (click)="editCondition()" *ngIf="!isReadOnly">Add Condition</button></h2>
<table class="mvd_table--primeng">
    <thead>
        <tr>
            <th class="w--icon">Select</th>
            <th>Condition</th>
            <th>Last Episode</th>
            <th>Occurrence Date</th>
            <th>MVD Monitoring</th>
            <th>Review Period</th>
            <th>Adaptive Equipment</th>
            <th class="w--icon">Edit</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let data of conditions" [formGroup]="data.formGroup">
            <td class="w--icon">
                <input type="checkbox" formControlName="selected">
            </td>
            <td>
                {{ data.customerIndividualMedicalConditionTypeDisplayValue }}
            </td>
            <td>
                {{ data.lastEpisodeDate | shortDate }}
            </td>
            <td>
                {{ data.occurrenceDate | shortDate }}
            </td>
            <td>
                {{ data.isMVDMonitoring | yesNo }}
            </td>
            <td>
                <ng-container *ngIf="data.durationTypeDisplayValue != undefined && data.durationValue != undefined && data.durationTypeDisplayValue.length > 0">
                    {{ data.durationValue }} - {{ data.durationTypeDisplayValue }}
                </ng-container>
            </td>
            <td>
                {{ data.isAdaptiveEquipment | yesNo }}
            </td>
            <td class="text-center">
                <a class="icon--edit" title="Edit Condition" href="javascript:void(0);" (click)="editCondition(data.id)" *ngIf="!isReadOnly"></a>
            </td>
        </tr>
    </tbody>
</table>